export enum IndustryStandardFilterKey {
  INDUSTRY,
  SIZE,
}

export enum IndustryStandardType {
  SECTOR = 'sector',
  SIZE = 'size',
}

export const CustomerSuccessManagerEmail = 'clientsuccess@intellect.co';
